import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const bonuses = [{
  color: 'bg-gold',
  textColor: 'text-navy',
  label: 'BONUS 1',
  title: 'Banco Universal de Prompts Docentes Inteligentes',
  desc: 'Prompts adaptables para ChatGPT, Gemini y Gamma. Planificaciones, evaluaciones, rúbricas e inclusión.',
  value: '$12.000'
}, {
  color: 'bg-electric',
  textColor: 'text-white',
  label: 'BONUS 2',
  title: 'Sistema "Planificación 10X" Paso a Paso',
  desc: 'De la idea a la planificación completa en 15 min. Flujo optimizado + material imprimible.',
  value: '$9.000'
}, {
  color: 'bg-emerald',
  textColor: 'text-white',
  label: 'BONUS 3',
  title: 'Creá tu Propio Material Digital',
  desc: 'Aprendé a construir tu banco personal de recursos. Independencia profesional total.',
  value: '$8.000'
}];
export function BonusSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-offwhite pt-12 pb-4 px-4 sm:px-6 lg:px-8" data-id="element-13">
      <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-14">
        <div className="text-center mb-8" data-id="element-15">
          <span className="inline-block font-montserrat font-bold text-gold text-sm tracking-widest uppercase mb-2" data-id="element-16">
            🎁 BONUS EXCLUSIVOS
          </span>
          <h2 className="font-playfair font-bold text-2xl sm:text-[36px] leading-[1.2] text-navy" data-id="element-17">
            Comprás Hoy y te Llevás{' '}
            <span className="text-gold" data-id="element-18">3 Libros Extra Gratis</span>
          </h2>
        </div>

        <div className="space-y-3" data-id="element-19">
          {bonuses.map((b, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 p-4" data-id="element-20">
              <div className={`${b.color} ${b.textColor} rounded-lg px-3 py-1.5 font-montserrat font-bold text-xs tracking-wider flex-shrink-0`} data-id="element-21">
                🎁 {b.label}
              </div>
              <div className="flex-1 min-w-0" data-id="element-22">
                <h4 className="font-inter font-bold text-navy text-sm leading-snug" data-id="element-23">
                  {b.title}
                </h4>
                <p className="font-inter text-xs text-gray-500 leading-snug mt-0.5" data-id="element-24">
                  {b.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-right" data-id="element-25">
                <span className="font-inter text-xs text-gray-400 line-through" data-id="element-26">
                  {b.value}
                </span>
                <span className="block font-montserrat font-bold text-emerald text-sm" data-id="element-27">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}